module.exports = __webpack_public_path__ + "static/img/KV.6c9add6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/11/KV.jpg
// module id = D9g3
// module chunks = 2